import { BackofficePrestationType, OrderStatus, Prisma } from "@prisma/client";
import { simpleBasketTypeValues } from "./basket.types";

export const discountCodeValues = Prisma.validator<Prisma.DiscountCodeDefaultArgs>()({
  include: {
    discount: true,
    event: true,
    organiser: {
      include: {
        admin: true,
      },
    },
    pricings: {
      include: {
        pricing: {
          include: {
            backofficePrestation: true,
            equipment: true,
          },
        },
      },
    },
    _count: {
      select: {
        orderItemDiscountCodes: {
          where: {
            orderItem: {
              order: {
                status: { in: [OrderStatus.pending, OrderStatus.success] },
              },
            },
          },
        },
      },
    },
  },
});

export type DiscountCode = Prisma.DiscountCodeGetPayload<typeof discountCodeValues>;

// `usesCount` is the number of units discounted by the code across live orders (one use = one
// discounted unit); `_count` counts raw discounted lines and only tells whether the code was used.
export type DiscountCodeWithUses = DiscountCode & { usesCount: number };

export interface DiscountCodesFilters {
  search?: string;
  prestationType?: BackofficePrestationType;
}

/* Variables mainly used in discount codes checks  */
export const nonCumulableBasketCodesValues = Prisma.validator<Prisma.DiscountCodeDefaultArgs>()({
  select: {
    id: true,
    name: true,
    ticketingId: true,
    pricings: {
      select: {
        pricingId: true,
        quantityLeft: true,
      },
    },
  },
});

export type NonCumulableCode = Prisma.DiscountCodeGetPayload<typeof nonCumulableBasketCodesValues>;

export const discountCodeCheckSelect = Prisma.validator<Prisma.DiscountCodeSelect>()({
  ...simpleBasketTypeValues.select.discountCode.select,
  organiserId: true,
});

export const discountCodeCheckValues = Prisma.validator<Prisma.DiscountCodeDefaultArgs>()({
  select: discountCodeCheckSelect,
});

export type DiscountCodeCheck = Prisma.DiscountCodeGetPayload<typeof discountCodeCheckValues>;

/* End of discount codes checks variables */
